import ModelFactory from '../model-factory';
import {
  BaseModel, Location, ResourceFamily, ElementProperty,
  ElementCategory,
} from '../models';
import User from '../user/model';

export default class CatalogResource extends BaseModel {
  constructor(data = {}) {
    super(data);

    this.icon = data.resource_alias;
    this.hostName = data.host_name || null;
    this.descriptionRequired = data.zdesc_req === 1;
    this.descriptionLabel = data.zdesc_title || null;
    this.tooltip = data.zmics_alt_cat || null;

    this.location = null;
    if (data.location != null) {
      this.location = new Location(data.location);
    }

    this.family = null;
    if (data.family != null) {
      this.family = new ResourceFamily(data.family);
    }

    this.properties = null;
    if (data.properties != null) {
      this.properties = [];

      if (data.properties.length) {
        this.properties = data.properties.map((property) => new ElementProperty(property));
      }
    }

    this.category = null;
    if (data.category != null) {
      this.category = new ElementCategory(data.category);
    }

    this.catalogCategory = null;
    if (data.catalogfamily != null) {
      this.catalogCategory = new ElementCategory(data.catalogfamily);
    }

    this.workflow = [];
    if (data.workflow != null) {
      this.workflow = data.workflow.map((property) => new User(property));
    }
  }
}

export const modelFactory = new ModelFactory('nr', (data) => new CatalogResource(data));
